import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M12 10V2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m4.93 10.93 1.41 1.41", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 18h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 18h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m19.07 10.93-1.41 1.41", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M22 22H2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m16 6-4 4-4-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 18a4 4 0 0 0-8 0", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Sunset";
const Sunset = memo(themed(Icon));
export {
  Sunset
};
//# sourceMappingURL=sunset.js.map
